import { ChakraV3 } from '../';

export interface UseToastReturn {
  toaster: ReturnType<typeof ChakraV3.createToaster>;
  successToast: (title: string) => void;
  errorToast: (title: string) => void;
  promiseToast: typeof ChakraV3.toaster.promise;
}

export const useToast = (): UseToastReturn => {
  const toaster = ChakraV3.toaster;
  const promiseToast = toaster.promise;

  const successToast = (title: string) => {
    ChakraV3.toaster.create({
      title,
      type: 'success',
      closable: true,
    });
  };

  const errorToast = (title: string) => {
    ChakraV3.toaster.create({
      title,
      type: 'error',
      closable: true,
    });
  };

  return {
    successToast,
    errorToast,
    promiseToast,
    toaster,
  };
};
